import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getActiveItem } from './sidebar.helper';
import { SidebarItem, SidebarProps } from './sidebar.types';

export function useSidebar(props: SidebarProps) {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [isResponsiveExpanded, setIsResponsiveExpanded] = useState(false);
  const [activeItem, setActiveItem] = useState<SidebarItem | null>(null);
  const [items, setItems] = useState(props.items);
  const location = useLocation();

  const sidebarItemProps = useMemo(() => {
    return {
      items,
      isSidebarExpanded,
      setIsSidebarExpanded,
      isResponsiveExpanded,
      setIsResponsiveExpanded,
    };
  }, [isResponsiveExpanded, isSidebarExpanded, items]);

  useEffect(() => {
    // Append internal handlers to each item
    setItems(
      props.items.map((item) => ({
        ...item,
        callback: () => {
          item.callback?.(item);
          setIsResponsiveExpanded(false);
          setActiveItem(item);
        },
      })),
    );
  }, [props.items]);

  useEffect(() => {
    const activeItem = getActiveItem(props.items, location.pathname);
    if (activeItem) setActiveItem(activeItem);
  }, [location.pathname, props.items]);

  return {
    activeItem,
    sidebarItemProps,
    ...sidebarItemProps,
  };
}
